var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard"},[(!_vm.hideSidebar)?_c('Sidebar',{staticClass:"dashboard__sidebar"}):_vm._e(),_c('Header',{staticClass:"dashboard__header"}),_c('main',{staticClass:"dashboard__main"},[_vm._t("default")],2),_c('AppFooter',{staticClass:"dashboard__footer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }